export default "__VITE_ASSET__BuPmqnut__"